// お知らせのjsはlayout/header.jsと共通
import {setFlashError, showFailedMessage, showFlashMessage} from '../../error'
import {getPreviewsDownloadStatus, postPreviewsDownload, getPdfStatus} from "../api/report";
import axios from "axios";

let targetBtn;

const setTargetBtn = (downloadBtn) => {
  targetBtn = downloadBtn
}

$(document).on('turbolinks:load', () => {
  initDownloadBtns()
  initDeleteModal()
  showFlashMessage()
  onHoverShowTooltip()
})

const initDeleteModal = () => {
  $('a[href="#modalDelete"]').on('click', (e) => {
    $('#modalDelete form').data('report-id', $(e.currentTarget).data('report-id'))
  })
  $('#modalDelete form').on('submit', (e) => {
    e.preventDefault()
    $("a[data-report-id=" + $(e.currentTarget).data('report-id') + "]").closest('form').trigger('submit')
  })
}

const initDownloadBtns = () => {
  const downloadBtns = $('.js-home-download-btn')

  downloadBtns.toArray().forEach(downloadBtn => {
    $(downloadBtn).on('click', async (e) => {
      e.preventDefault()

      setTargetBtn($(downloadBtn))
      changeDownloadBtnForGenerating($(downloadBtn))

      const report_id = $(downloadBtn).data('report-id')

      const response = await getPdfStatus({report_id})
      if (response === undefined || response.status !== 200) return

      const {pdf_status, unprocessed_pages} = response.data

      if (pdf_status === 'ok') {
        changeDownloadBtnForDownloading()

        await downloadPdf(report_id)
        return
      }

      unprocessed_pages.forEach(page =>
        sendRequestToPreviewsPage({
          page,
          status: 'loading',
          download: true,
          report_id
        })
      )

      startMonitoringDownloadStatus({
        report_id: $(downloadBtn).data('report-id'),
        user_id: $(downloadBtn).data('user-id')
      })
    })
  })
}


const startMonitoringDownloadStatus = ({user_id, report_id}) => {
  const interval = setInterval(async () => {
    try {
      await monitorDownloadStatus(interval, user_id, report_id)
    } catch (error) {
      console.error({error})
      clearInterval(interval)
      setFlashError('danger', 'ファイルをダウンロードできませんでした')
    }
  }, 5000)

  switch (gon.pdf_status) {
    case 'ok':
      changeDownloadBtnForDownload()
      return
    case 'not_found':
      setFlashError('danger', 'ファイルをダウンロードできませんでした')
      return
    default:
      break
  }
}

const monitorDownloadStatus = async (interval, user_id, report_id) => {
  const config = {
    headers: {'X-Requested-With': 'XMLHttpRequest'},
    responseType: "blob",
    params: {user_id, report_id}
  }
  const response = await getPreviewsDownloadStatus({config})

  const isAllSheetPDFProcessed = response !== undefined && response.status === 200
  if (!isAllSheetPDFProcessed) return

  clearInterval(interval)
  await downloadPdf(report_id)
}

const downloadPdf = async (report_id) => {
  const params = {report_id: report_id}
  const response = await postPreviewsDownload(params)
  if (response?.data === undefined || response.status !== 200) return

  window.location.href = response.data.url

  const errorMessage = response.data.message
  errorMessage
    ? setFlashError('danger', errorMessage)
    : changeDownloadBtnForDownload()

  setTargetBtn(null)
}

const changeDownloadBtnForGenerating = () => {
  targetBtn.find('.generating-pdf-on-home').show()
  targetBtn.find('.download-on-home').hide()
  targetBtn.find('.downloading-pdf-on-home').hide()
  targetBtn.prop('disabled', true)
}

const changeDownloadBtnForDownloading = () => {
  targetBtn.find('.downloading-pdf-on-home').show()
  targetBtn.find('.download-on-home').hide()
  targetBtn.find('.generating-pdf-on-home').hide()
  targetBtn.prop('disabled', true)
}


const changeDownloadBtnForDownload = () => {
  targetBtn.find('.download-on-home').show()
  targetBtn.find('.downloading-pdf-on-home').hide()
  targetBtn.find('.generating-pdf-on-home').hide()
  targetBtn.prop('disabled', false)
}

const sendRequestToPreviewsPage = async ({page, status, download, report_id}) => {
  if (status == 'hide' || status == 'error') return

  if (download) {
    gon.isDownloadRequestSent = true
  }

  try {
    const path = `/previews/${report_id}/page`
    const options = {
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      params: {page: page, format: 'js'}
    }
    let response
    while (true) {
      response = await axios.get(path, options)
      if (response.status != 202) break
      await sleep(500)
    }
  } catch (error) {
    console.error({error})
  }
}

const onHoverShowTooltip = () => {
  const tooltip = $(".js-tooltipHelp")
  const tooltipContent  = $(".m-tooltipHelp")
  const secondsForFading = 200

  const onHoverShow = () => tooltipContent.show().animate({opacity: 1.0}, secondsForFading)
  const onUnhoverHide = () => {
    tooltipContent.animate({opacity: 0}, secondsForFading)
    setTimeout(() => tooltipContent.hide(), secondsForFading)
  }

  tooltip.hover(onHoverShow, onUnhoverHide)
}

